import React, { useState, useEffect } from 'react';
import { ChevronUp } from 'lucide-react';

const ScrollToTop = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 500);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <button
      type="button"
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      data-testid="scroll-to-top-button"
      aria-label="Scroll to top"
      className={`fixed bottom-8 right-8 w-14 h-14 rounded-full bg-white shadow-xl border-2 border-[#00BCE4] flex items-center justify-center z-50 transition-all duration-500 hover:bg-[#00BCE4] hover:text-white group ${
        show ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10 pointer-events-none'
      }`}
    >
      <ChevronUp size={24} className="text-[#00BCE4] group-hover:text-white transition-colors" />
    </button>
  );
};

export default ScrollToTop;
